import PointsTransfer from '@/features/points-management/points-transfer';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/points-management/points-transfer/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <PointsTransfer />;
}
